import React from 'react'
import { HeaderNuevoProps } from '../HeaderContentNuevo'
import { Box, Stack, Tooltip, Button } from '@mui/material'
import SplitButton from 'src/components/forms/SplitButton'
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from '@mui/icons-material/Save';
import { InfoNuevoMensajeDesktop } from 'src/pages/sistema/components/desktop/InfoNuevoMensajeDesktop';
import { useNavigate } from 'react-router-dom';

export const HeaderDesktopNuevo = ({ codSistemaPrincipal, codSistema, codSistemaTipo, acciones }: HeaderNuevoProps) => {

    const { saveHandler, sendHandler } = acciones

    const navigation = useNavigate()

    return (
        <Box
            display='flex'
            justifyContent='space-between'
            alignItems='center'
            width='100%'
            py={4}
        >
            <InfoNuevoMensajeDesktop codSistemaPrincipal={codSistemaPrincipal} codSistema={codSistema} codSistemaTipo={codSistemaTipo} />
            <Stack direction='row' spacing={2} >
                {
                    saveHandler &&
                    <Tooltip title='Guardar operación'>
                        <Button
                            variant='outlined'
                            endIcon={<SaveIcon />}
                            onClick={saveHandler}
                        >
                            Guardar
                        </Button>
                    </Tooltip>
                }
                {
                    sendHandler && <Button
                        variant='contained'
                        endIcon={<SendIcon />}
                        onClick={sendHandler}
                    >
                        Enviar
                    </Button>
                }
                <Tooltip title='Cerrar'>
                    <Button variant='contained' onClick={() => navigation('/')} color='error'>
                        <CloseIcon />
                    </Button>
                </Tooltip>
            </Stack>
        </Box>
    )
}
